import React, {useContext,useState} from 'react'
import {MyContext} from '../Actions/UAuth'
// React Notification
import { NotificationContainer,NotificationManager} from 'react-notifications'

function Register(){
    const {toggleNav,registerUser} = useContext(MyContext);
    const initialState = {
        userInfo:{
            name:'',
            email:'',
            password:'',
            officecode:'',
            designationcode:'',
        },
        errorMsg:'',
        successMsg:'',
    }
    const [state,setState] = useState(initialState);

    // On Submit the Registration Form

    const submitForm = async (event) => {
        event.preventDefault();
        const data = await registerUser(state.userInfo);
        if(data.success){
            setState({
                ...initialState,
                successMsg:data.message,
            });
        }
        else{
            setState({
                ...state,
                successMsg:'',
                errorMsg:data.message
            });
        }
    }

    // On change the Input Value (name, email, password)
    const onChangeValue = (e) => {
        setState({
            ...state,
            userInfo:{
                ...state.userInfo,
                [e.target.name]:e.target.value
            }
        });
    }
    
    // Show Message on Success or Error
    
    if(state.errorMsg){
        NotificationManager.error(state.errorMsg, 'Error!');
    }
    if(state.successMsg){
        NotificationManager.success(state.successMsg, 'Successfully!'); 
    }     
    return(
        <div>    
        <NotificationContainer/> 
        <div className="bg"></div>
        <div className="bg bg2"></div>
        <div className="bg bg3"></div>         
        <div className="register-box content_login_registr">
            <div className="register-logo">
            <img src={`${process.env.PUBLIC_URL}/asset/images/wms.png`} className="faa-pulse animated" width="100" height="80" alt="logo"/>
            <h1>Sign Up</h1>
            </div>
            <div className="register-box-body">
            <form onSubmit={submitForm} noValidate>
                <div className="form-group required">
                    <label className="control-label">Full Name</label>
                    <input name="name" className="form-control" required type="text" value={state.userInfo.name} onChange={onChangeValue} placeholder="Enter your name"/>
                </div>
                <div className="form-group required">
                    <label className="control-label">Email</label>
                    <input name="email" className="form-control" required type="email" value={state.userInfo.email} onChange={onChangeValue} placeholder="Enter your email"/>
                </div>
                <div className="form-group required">
                    <label className="control-label">Password</label>
                    <input name="password" className="form-control" required type="password" value={state.userInfo.password} onChange={onChangeValue} placeholder="Enter your password"/>
                </div>
                <div className="form-group required">
                <label className="control-label">Office</label>
                    <select value={state.userInfo.officecode} required name="officecode" className="form-control" onChange={onChangeValue}>
                        <option value="">Select Office Name</option>
                        <option value="20501">HO Office</option>                     
                    </select>                    
                </div>   
                <div className="form-group required">
                <label className="control-label">Designation</label>
                    <select value={state.userInfo.designationcode} required name="designationcode" className="form-control" onChange={onChangeValue}>
                        <option value="">Select Designation</option>
                        <option value="113">Admin</option>                     
                    </select>                    
                </div> 
                <div className="form-group">
                    <button type="submit" className="btn btn-primary btn-block btn-flat">Sign Up</button>
                </div>
            </form>
            
            <div className="form-group">
                <button className="btn btn-primary btn-block btn-flat" onClick={toggleNav}>Login</button>
            </div>
            </div>
        </div>
        <footer className="main-footer" style={{marginLeft: '0px',position: 'fixed',bottom: '0px',height: '45px',width:'100%'}}><strong>Designed & Developed By  <a href="http://guj.nic.in">National Informatics Centre Gujarat State Centre </a>.</strong> Block-13 2nd floor, New Sachivalaya, Gandhinagar(Gujarat)</footer>
        </div>
    );
}
export default Register